import { mapGetters, mapState } from 'vuex';

import { ALL_AD_ACCOUNTS_KEY } from './constants';
import AdAccountCheckbox from './checkbox';

// Re-export for backward compatibility
export { ALL_AD_ACCOUNTS_KEY };
import { FILTER_KEYS, FILTER_ITEM_CLASS } from '@consts';

import { refineAccountName } from '../helper';
import FilterMixin from '../mixin';

import { isValueExist } from '@/utils/utils';

const { AD_ACCOUNT_ID } = FILTER_KEYS;

const sortByChannel = R.sortBy(R.prop('channel'));

export default {
    name: 'ChannelFilter',
    mixins: [FilterMixin],
    props: {
        handleSubmit: {
            type: Function,
        },
        selectedOption: {
            type: Array,
        },
        enableBlock: { type: Boolean, default: true },
        filterVisible: {
            type: Boolean,
            default: false,
        },
        allowEmptyValue: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        tagList: {
            handler() {
                const { getSelectedOption } = this;

                const selectedTags = getSelectedOption(AD_ACCOUNT_ID);

                this.selectedItems = R.compose(
                    R.filter(Boolean),
                    R.pluck('filterBy')
                )(selectedTags);
            },
        },
        tableAdAccounts: {
            handler(tableAdAccounts) {
                this.refineAdAccounts(tableAdAccounts);
            },
            deep: true,
            immediate: true,
        },
    },
    data() {
        return {
            values: {
                type: AD_ACCOUNT_ID,
                value: '',
            },
            adAccountList: [],
            selectedItems: [],
        };
    },
    computed: {
        ...mapState('newDashboard', ['tableAdAccounts']),
        ...mapGetters('newDashboard', ['adAccounts']),
    },
    methods: {
        refineAdAccounts(tableAdAccounts) {
            const getRefinedName = refineAccountName.bind(this);
            const dataSourceList = (tableAdAccounts || []).map((asset) => {
                const refinedName = getRefinedName(asset);

                return {
                    ...asset,
                    name: refinedName,
                };
            });

            const sortedAdAccountList = [...sortByChannel(dataSourceList)];
            const _adAccountList = Object.freeze(sortedAdAccountList);

            this.adAccountList = _adAccountList;
            this.$emit('updateAdAccountList', _adAccountList);
        },
        emitFilter() {
            const { values, currentState: state } = this;
            const { type, value } = values;

            const updatedValue = { type, filterBy: value };

            this.$emit('update', { value: updatedValue, state });
        },
        renderAdAccountOptions() {
            const {
                values,
                isAutoComplete,
                adAccountList,
                translateOr: tOr,
                highlightMatchingText,
                normalizeText,
                keywords,
                prefix,
                enableBlock,
                selectedOption,
                selectedItems: _selectedItems,
                handleSubmit,
                allowEmptyValue,
            } = this;

            const { type } = values;

            const selectedItems = isValueExist(selectedOption)
                ? selectedOption
                : _selectedItems;

            const filterText = normalizeText(keywords);

            return isAutoComplete ? (
                adAccountList
                    .filter(({ name }) => {
                        const filterTitle = normalizeText(
                            tOr(`FILTERS.${type}`, type)
                        );

                        return (
                            `${filterTitle}${name}`
                                .toLowerCase()
                                .indexOf(filterText) > -1
                        );
                    })
                    .map(({ name, channelId }) => {
                        return (
                            <li
                                class={FILTER_ITEM_CLASS}
                                onClick={() => {
                                    this.values = R.assoc(
                                        'value',
                                        channelId,
                                        values
                                    );
                                }}
                            >
                                <p
                                    domProps={{
                                        innerHTML: highlightMatchingText(
                                            `${prefix}${name}`
                                        ),
                                    }}
                                />
                            </li>
                        );
                    })
            ) : (
                <AdAccountCheckbox
                    enableBlock={enableBlock}
                    allowEmptyValue={allowEmptyValue}
                    options={adAccountList}
                    selectedItems={selectedItems}
                    normalizeText={normalizeText}
                    onSubmit={(adAccounts) => {
                        if (adAccounts.length) {
                            this.values = R.assoc('value', adAccounts, values);
                        }

                        handleSubmit && handleSubmit(this.values);
                    }}
                />
            );
        },
    },
    render() {
        const {
            shouldHideFilter,
            filterVisible,
            getCommonHeader,
            renderAdAccountOptions,
        } = this;

        if (shouldHideFilter && !filterVisible) return null;

        return (
            <div>
                {getCommonHeader()}
                {renderAdAccountOptions()}
            </div>
        );
    },
};
